const BrandFilter = {
  data() {
    return {
      activeBrands: this.activeItems
    }
  },
  props: [
    'activeItems'
  ],
  watch: {
    activeItems(newValue) {
      this.activeBrands = newValue
    }
  },
  methods: {
    handleInput: function(event) {
      bus.$emit('brand_filter', event.target.value)
    },
  }
}

export default BrandFilter
